import(/* webpackMode: "eager" */ "/home/tresno/projects/watchinspect-nextjs/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientLayout"] */ "/tmp/claude-1000/-home-tresno-projects/6a75db9f-cce6-424a-8f84-9edf2de2e863/scratchpad/wi-build/app/client-layout.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/claude-1000/-home-tresno-projects/6a75db9f-cce6-424a-8f84-9edf2de2e863/scratchpad/wi-build/styles/globals.css");
